"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModifiedNextBusinessDay = ModifiedNextBusinessDay;
exports.ModifiedPreviousBusinessDay = ModifiedPreviousBusinessDay;
exports.ModifiedPaymentDate = ModifiedPaymentDate;
const holidays_1 = require("./holidays");
function ModifiedNextBusinessDay(date_) {
    let date = date_.copy();
    while (date.isWeekend() || (0, holidays_1.IsHoliday)(date)) {
        date = date.increment();
    }
    return date;
}
function ModifiedPreviousBusinessDay(date_) {
    let date = date_.copy();
    while (date.isWeekend() || (0, holidays_1.IsHoliday)(date)) {
        date = date.decrement();
    }
    return date;
}
// We return the ModifiedNextBusinessDay, **UNLESS** it falls on the
// next month. If so, return the ModifiedPreviousBusinessDay.
function ModifiedPaymentDate(date) {
    const next_date = ModifiedNextBusinessDay(date);
    if (next_date.month === date.month) {
        return next_date;
    }
    return ModifiedPreviousBusinessDay(date);
}
